import React from 'react'
import { makeStyles } from '@material-ui/core'
import SocialNetworkIcon from './social-network-icon/social-network-icon'
import './social-network-icons.css'
import { socialNetworkIcons } from '../../../../../utils/constants'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(() => ({
  socialNetworkIcons: {
    float: 'right',
    display: 'flex',
    alignItems: 'center'
  }
}))

const SocialNetworkIcons = () => {
  const brand = useSelector((state) => state.reducer.brand)
  const classes = useStyles()

  return (
    <div className={classes.socialNetworkIcons}>
      {Object.keys(socialNetworkIcons).map(
        (socialNetwork) =>
          brand?.socialNetworkLinks[socialNetwork] !== '' && (
            <SocialNetworkIcon
              key={socialNetwork}
              link={brand?.socialNetworkLinks[socialNetwork]}
              name={socialNetwork}
              image={socialNetworkIcons[socialNetwork]}
            />
          )
      )}
    </div>
  )
}

export default SocialNetworkIcons
